export default __webpack_public_path__ + "static/info-messages-empty-state-0f4e547a4504e27edc637866100a9e28f70a231628b90f336080f9a7ced3ece0.png";